/**
 * 顧問委員會
 * Created at 2021-10-02 15:53
 * @author teapot
 */
import { Image, List, Modal } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import Config from "../../../config";
import {
  adviserAsync,
  setAdviserItem,
  setAdviserModel,
} from "../../../store/AboutStore";
import "./index.css";
import title from "./image/adviser-title.png";
import titleCN from "./image/adviser-cn.png";
import { locals } from "../../../i18n";
import AddviserAddress from "./adviser-address";
const Adviser = () => {
  const { t } = useTranslation();
  const { adviserList, adviserItem, adviserModel } = useAppSelector(
    (state: RootState) => state.about
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(adviserAsync());
    console.log("11111我说老是我是不是不太懂事");
  }, [dispatch]);

  return (
    <div className="adviser">
      <AddviserAddress></AddviserAddress>
      {/* <div className='line'></div> */}
      {/* <div className="adviser-title adviser-title-size">
        {t("nav_us_adviser")}
      </div> */}
      <Image
        src={locals() === "zh-CN" ? titleCN : title}
        preview={false}
        className="title-bottom"
      />

      <List
        grid={{
          gutter: 16,
          xs: 1,
          sm: 2,
          md: 2,
          lg: 2,
          xl: 2,
          xxl: 3,
        }}
        locale={{ emptyText: t("nodata") }}
        dataSource={adviserList}
        renderItem={(item) => {
          return (
            <List.Item
              onClick={() => {
                dispatch(setAdviserItem(item));
              }}
            >
              <div className="adviser-item">
                <Image
                  alt={item.name}
                  className={"adviser-item-img"}
                  src={`${Config.MAIN_URL}${item.img}`}
                  preview={false}
                />
                <div className="adviser-placeholder adviser-item-right adviser-item-image-title news-item-image-title-phone">
                  {item.name}
                </div>
              </div>
            </List.Item>
          );
        }}
      />

      <Modal
        visible={adviserModel}
        closable={false}
        width={700}
        onCancel={() => {
          dispatch(setAdviserModel(false));
        }}
        footer={null}
        bodyStyle={{
          backgroundColor: "#f5f5f5",
        }}
      >
        {adviserItem ? (
          <div className="adviser-item">
            <Image
              alt={adviserItem.name}
              className={"adviser-item-img"}
              src={`${Config.MAIN_URL}${adviserItem.img}`}
              preview={false}
            />
            <div className="adviser-placeholder adviser-item-right adviser-item-image-title news-item-image-title-phone">
              {adviserItem.name}

              <div className="tinktank-item-middle-content tinktank-item-middle-content-phone">
                {adviserItem.title &&
                  adviserItem.title.split(";").map((v, k) => {
                    return <div key={k}> {v}</div>;
                  })}
              </div>

              {adviserItem.pdf ? (
                <div
                  className="More"
                  onClick={() => {
                    window.location.href = `${Config.MAIN_URL}${adviserItem.pdf}`;
                  }}
                >
                  <span className="underline">了解更多 </span> <span>→</span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default Adviser;
